export type EventTypeString = 'SCROLL_UP_ABOVE_COLLAPSE';

export const eventType: EventTypeString = 'SCROLL_UP_ABOVE_COLLAPSE';

export type EventPayload = {
  scrollDirection: 'up' | 'down',
  isAboveCollapse: boolean,
};

export type EventType = {
  type: EventTypeString,
} & EventPayload;

export const eventBuilder = (payload: EventPayload): EventType => ({
  type: eventType,
  ...payload,
});
